module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.3759629be32bb8b55b21.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.ttf
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.ttf
// module chunks = styles